// extracted by mini-css-extract-plugin
export default {"frame":"ButtonPreview_frame__Wqx1F","stage":"ButtonPreview_stage__7Es0O"};